import React, { useEffect } from 'react';

import { clearRedirectUrl, getRedirectUrl } from '../../../utils/redirect/redirect';

export const Clean = () => {
  useEffect(() => {
    const handleAppClose = () => {
      if (getRedirectUrl()) {
        clearRedirectUrl();
      }
    };

    window.addEventListener('beforeunload', handleAppClose);

    return () => {
      window.removeEventListener('beforeunload', handleAppClose);
    };
  }, []);

  return <></>;
};
